import {Component, Injectable, Input, OnChanges} from '@angular/core';

import {WeeklyScheduleComponent} from './weekly-schedule/weekly-schedule.component';
import {Calendar, Group, Timezone} from 'src/app/models';
import {GroupsService, SchedulesService} from 'src/app/services';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-scheduler',
    templateUrl: './scheduler.component.html',
    styleUrls: ['./scheduler.component.scss']
})
@Injectable({
    providedIn: 'root'
})

export class SchedulerComponent implements OnChanges {
    @Input() currentGroup: Group;
    spinner = true;
    ready = false;
    failed = false;
    @Input() groupId: any;
    onCalls: any[] = [];
    emptyEntry: any = {'id': -1, 'color': 'none'};
    weeks: any[] = [];
    recipients: any[] = [];
    calendarMonth: Calendar;
    currentMonthString = '';
    currentDate = new Date();
    currentYear = this.currentDate.getFullYear();
    currentMonth = this.currentDate.getMonth();
    selectedMonth = this.currentMonth;
    currentDayOfMonth = this.currentDate.getDate();
    colors = [
        'blue',
        'black',
        'orange',
        'purple',
        'brown',
        'yellow',
        'green',
        'grey',
        'red'
    ];
    timezone = '';
    timezones = [];
    participantCount = 0;
    participants = [];

    constructor(private scheduleService: SchedulesService,
                private dialog: MatDialog,
                private groupsService: GroupsService,
                private schedulesService: SchedulesService) {
    }

    // eslint says it won't trigger this, but it seems to do it anyway so ignoring unless it causes problems
    // eslint-disable-next-line @angular-eslint/contextual-lifecycle
    ngOnChanges() {
        this.onCalls = [];
        this.spinner = true;
        this.ready = false;
        this.onCalls = [];
        this.weeks = [];
        this.recipients = [];
        this.calendarMonth = new Calendar();
        this.currentMonthString = '';
        this.currentDate = new Date();
        this.currentYear = this.currentDate.getFullYear();
        this.currentMonth = this.currentDate.getMonth();
        this.currentMonth += 1;
        this.selectedMonth = this.currentMonth;
        this.currentDayOfMonth = this.currentDate.getDate();

        this.groupsService.getGroup(this.currentGroup.id).subscribe(res => {
            this.onCalls = res.members;
        });

        this.schedulesService.getAllTimezones().subscribe((timezones: Timezone[]) => {
            this.timezones = timezones;
            this.timezones.sort((a, b) => (a.id > b.id) ? 1 : -1);
        });

        this.scheduleService.getScheduleByGroupID(this.currentGroup.id).subscribe(schedule => {
            this.timezone = schedule[0] ? schedule[0].timezone : Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.createCalendar();
        });
    }

    openWeeklySchedule(week) {
        this.dialog.open(WeeklyScheduleComponent, {
            width: '80%',
            height: '80%',
            data: {
                group: this.currentGroup,
                week: week,
                month: this.currentMonth,
                year: this.currentYear,
                recipients: this.recipients,
                timezone: this.timezone
            }
        });
    }

    parseMonth(month) {
        this.weeks = [];
        const numberOfWeeks = month.length / 7;
        const monthHold = month.slice();
        for (let i = 0; i < numberOfWeeks; i++) {
            this.weeks.push(monthHold.splice(0, 7));
        }
        this.parseWeeks();
    }

    parseWeeks() {
        this.weeks.forEach(week => {
            week.forEach(day => {
                day.selected = '';
                if (day.date === this.currentDayOfMonth && day.month === this.selectedMonth) {
                    day.selected = 'selected';
                }
                day.coverage.forEach(event => {
                    if (event.participant_type === 'EMPTY') {
                        event.color = '';
                    } else {
                        const matchingParticipant = this.recipients.find(participant => participant.participant_id === event.participant_id);
                        event.color = matchingParticipant.color;
                    }
                    if (event.carryover) {
                        if (event.color === 'blue' || event.color === 'black' || event.color === 'purple' || event.color === 'brown') {
                            event.color += ' patterned-for-dark';
                        } else {
                            event.color += ' patterned-for-light';
                        }
                    }
                });
            });
        });
    }

    randomColor() {
        return this.colors[Math.floor(Math.random() * this.colors.length) + 1];
    }

    changeDay(day) {
        this.currentDayOfMonth = day.date;
        this.selectedMonth = day.month;
        this.parseWeeks();
    }

    changeMonth(direction) {
        this.reset();
        this.currentMonth += direction;
        if (this.currentMonth < 1) {
            this.currentMonth = 12;
            this.selectedMonth = this.currentMonth;
            this.changeYear(-1);
        } else if (this.currentMonth > 12) {
            this.currentMonth = 1;
            this.selectedMonth = this.currentMonth;
            this.changeYear(1);
        } else {
            this.selectedMonth = this.currentMonth;
            this.createCalendar(this.currentMonth, this.currentYear);
        }
    }

    changeYear(direction) {
        this.reset();
        this.currentYear += direction;
        this.createCalendar(this.currentMonth, this.currentYear);
    }

    createCalendar();
    createCalendar(month, year);
    createCalendar(month?, year?) {
        this.spinner = true;
        this.scheduleService.getCalendar(this.currentGroup.id, year, month, this.timezone).subscribe({
            next: res => {
                this.calendarMonth = res;
                this.recipients = this.calendarMonth.participants;
                this.recipients = this.recipients ? this.recipients.filter(recipient => recipient.participant_type !== 'EMPTY') : [];
                this.currentMonthString = this.calendarMonth.name;
                this.recipients.forEach((participant, i) => {
                    if (this.participants.find(p => p.participant_name === participant.participant_name) != undefined) {
                        participant.color = this.participants.find(p => p.participant_name === participant.participant_name).color;
                    } else {
                        participant.color = this.colors[this.participantCount % this.colors.length];
                        this.participants[this.participantCount] = participant;
                        this.participantCount++;
                    }
                    this.updateRecipients(participant.participant_name, i);
                });
                this.parseMonth(this.calendarMonth.days);
                this.spinner = false;
                this.ready = true;
            }, error: () => this.error()
        });
    }

    updateRecipients(name, i) {
        this.recipients[i].name = name;
        this.spinner = false;
        this.ready = true;
        this.failed = false;
    }

    error() {
        this.spinner = false;
        this.ready = true;
        this.failed = true;
    }

    reset() {
        this.weeks = [];
        this.spinner = true;
        this.ready = false;
    }

    handleTimezoneChange(timezone: Timezone) {
        if (timezone && this.timezone !== timezone.id) {
            this.timezone = timezone.id;
            this.createCalendar(this.selectedMonth, this.currentYear);
        }
    }

    protected readonly intlForHTML = Intl;
}
